export default __webpack_public_path__ + "static/media/snooIcon.3cd254a2.svg";